var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M2.1,4.5V15h13.7V4.5 M7.9,10.9h4.6 M1,1v3.5h16V1H1z","stroke":"#000000","fill":"#FFFFFF"}})
}
var staticRenderFns = []

export { render, staticRenderFns }